import { deserialize, DocumentObject } from '@jsonapiworld/jsonapi-serializer';
import { backendApiGateway } from '~/client/backend';
import { MetaDataCursorPage, pagedMetaSchema } from '~/types/jsonapi';
import { VATCode } from '~/types/vat-bookkeeping';
import { buildJsonAPIQueryParams, jsonAPICursorPaginatorBuilder } from '~/utils/jsonapi-query';

export const VATCodeResourceType = 'vat-code';

export const fetchAllVATCodes = async (): Promise<VATCode[]> => {
  let allVATCodes: VATCode[] = [];
  let fetchedVATCodes: VATCode[] = [];
  let cursor: MetaDataCursorPage['cursor'] | null = null;
  const pageSize = 100;

  do {
    const pageBuilder = jsonAPICursorPaginatorBuilder({ size: pageSize });
    if (cursor) pageBuilder.cursor(cursor);
    const searchParams = buildJsonAPIQueryParams(pageBuilder);

    const { data: results } = await backendApiGateway.get<DocumentObject & { meta: unknown }>('/api/v1/vat-codes', {
      params: searchParams,
    });
    fetchedVATCodes = deserialize<VATCode>(results) as VATCode[];
    allVATCodes = allVATCodes.concat(fetchedVATCodes);
    const { page } = pagedMetaSchema.parse(results.meta);
    cursor = page.cursor;
  } while (fetchedVATCodes.length === pageSize);

  return allVATCodes;
};
